import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LanguagesService extends DataService {

  constructor(private httpclient: HttpClient) {
    super(httpclient);
    super.setBaseUrl('/api/language/');
  }

  getLocalizedItems() {
    return super.get({}, 'get-localized');
  }

  changeLanguage(model: any ) {
    return super.post(model, 'change-language');
  }

  availableLanguages() {
    return super.get({});
  }
}